export default __webpack_public_path__ + "static/media/offer-4.045ca960.webp";